import { render, staticRenderFns } from "./ModifierQuantityModal.vue?vue&type=template&id=b438a2ce&scoped=true"
import script from "./ModifierQuantityModal.vue?vue&type=script&lang=js"
export * from "./ModifierQuantityModal.vue?vue&type=script&lang=js"
import style0 from "./ModifierQuantityModal.vue?vue&type=style&index=0&id=b438a2ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b438a2ce",
  null
  
)

export default component.exports